import { getGenericDocuments, } from '@zurich/api/document';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
export const useGetGenericDocuments = ({ documentIds, }) => {
    const { t } = useTranslation();
    return useApiQuery({
        request: getGenericDocuments,
        // vars: { documentIds: documentIds.join(',') },
        params: {
            vars: {
                documentIds,
            },
        },
        options: {
            errorText: t('document.errors.loadDocument'),
        },
        queryOptions: {
            enabled: documentIds?.length > 0,
        },
    });
};
